module.exports = __webpack_public_path__ + "static/img/multipledoctor.d2d9462.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/multipledoctor.jpeg
// module id = VcCI
// module chunks = 7